import { z } from "zod";

export const BaseOutputSchema = z.object({
    errorMessage: z.string().nullish(),
    infoMessage: z.string().nullish(),
});

export type BaseOutput = z.infer<typeof BaseOutputSchema>;